module.exports = __webpack_public_path__ + "img/P10.6c53c707.png";